import {
  messageId,
  PropertyMeta,
  ValueObjectMetaEnum,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
/**
 * 案件並び順(値オブジェクト)
 *
 *
 *
 * updated_at_asc:
 * updated_at_desc:
 * project_control_number_asc:
 * project_control_number_desc:  */
export type ProjectSortCondition = z.infer<
  typeof projectSortConditionMeta.schema
>;
/**
 * 案件並び順(値オブジェクト)のメタデータ。
 *
 *  */
export const projectSortConditionMeta = new ValueObjectMetaEnum<
  [
    "updated_at_asc",
    "updated_at_desc",
    "project_control_number_asc",
    "project_control_number_desc"
  ]
>(
  "ProjectSortCondition",
  "\u6848\u4EF6\u4E26\u3073\u9806",
  messageId("lbl.\u6848\u4EF6\u4E26\u3073\u9806"),
  [
    "updated_at_asc",
    "updated_at_desc",
    "project_control_number_asc",
    "project_control_number_desc",
  ],
  {
    updated_at_asc:
      "code.\u4E26\u3073\u9806.\u66F4\u65B0\u65E5\u6642\u6607\u9806",
    updated_at_desc:
      "code.\u4E26\u3073\u9806.\u66F4\u65B0\u65E5\u6642\u964D\u9806",
    project_control_number_asc:
      "code.\u4E26\u3073\u9806.\u6848\u4EF6\u7BA1\u7406\u756A\u53F7\u6607\u9806",
    project_control_number_desc:
      "code.\u4E26\u3073\u9806.\u6848\u4EF6\u7BA1\u7406\u756A\u53F7\u964D\u9806",
  }
);
